// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.fees.singlefamily.RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { DeleteSingleFamilyListingFeesRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete_Args {
  postData: DeleteSingleFamilyListingFeesRequestDto;
}

export type RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete_Args
>;

/**
 * Deletes a fee for a single family listing
 */
export const useRentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete(args.postData, httpClient),
  });
};
